// extracted by mini-css-extract-plugin
module.exports = {"root":"locationCarousel_root__37SKC"};